import { useTranslation } from "react-i18next";
import { Container } from "../components/ui/Container";

export function Footer({ name, showYear }: { name: string; showYear?: boolean }) {
  const { t } = useTranslation();
  return (
    <footer className="bx-border bx-section-muted border-t py-10 text-center text-sm">
      <Container>
        <p className="bx-text-muted">{t("footer.credits", { name })}</p>
        {showYear ? (
          <p className="bx-text-subtle mt-1">© {new Date().getFullYear()}</p>
        ) : null}
        <p className="bx-text-subtle mt-2">IT Application Support · Oracle PL/SQL · Lisbon, Portugal</p>
      </Container>
    </footer>
  );
}
